import { Accordion } from 'react-bootstrap';
import { CategoryAccordionHeaderProps } from './categoryAccordion.types';

const CategoryAccordionHeader = ({ as, ...rest }: CategoryAccordionHeaderProps) => (
  <Accordion.Header as={as} {...rest} />
);

export default CategoryAccordionHeader;
